import React from 'react';
import { Select, MenuItem, Checkbox, ListItemText } from '@mui/material';

// A string is one value: never split on ',' (retailer/attribute names can contain commas).
export const toSelection = (v) => (Array.isArray(v) ? v : v ? [v] : []).filter(Boolean);

// Multi-select filter for a filter bar: an empty selection means "All".
// Render inside a <FormControl> with a matching <InputLabel>.
export default function MultiSelectFilter({ label, value, options, onChange }) {
  const selected = toSelection(value);
  const handleChange = (e) => onChange({ target: { value: toSelection(e.target.value) } });
  return (
    <Select
      multiple
      value={selected}
      label={label}
      onChange={handleChange}
      renderValue={(vals) => (vals.length <= 2 ? vals.join(', ') : `${vals.length} selected`)}
      MenuProps={{ PaperProps: { sx: { maxHeight: 360 } } }}
    >
      {(options || []).map((o) => (
        <MenuItem key={o} value={o} dense>
          <Checkbox size="small" checked={selected.includes(o)} sx={{ p: 0.5, mr: 1 }} />
          <ListItemText primary={o} />
        </MenuItem>
      ))}
    </Select>
  );
}
